import React, { createContext, useState, useContext, useCallback } from "react";
import { useGetTicketsOuverts } from "../hooks/useGetTicketsOuverts.js";
import { useGetTicketsFermes } from "../hooks/useGetTicketsFermes.js";
import { useGetClientTicketsOuverts } from "../hooks/useGetClientTicketOuvert.js";
import { useGetClientTicketsFermes } from "../hooks/useGetClientTicketFermes.js";
import { useAuth } from "./AuthContext.js";

const TicketContext = createContext();

export const useTickets = () => useContext(TicketContext);

export const TicketProvider = ({ children }) => {
  const [loadingOuvert, setLoadingOuvert] = useState(true);
  const [loadingFerme, setLoadingFerme] = useState(true);
  const [errorOuvert, setErrorOuvert] = useState(null);
  const [errorFerme, setErrorFerme] = useState(null);
  const [isConnectedToListTicket, setIsConnectedToListTicket] = useState(true);
  const { isConnected } = useAuth();

  const { tickets : ticketsOuvert, refetch: fetchTicketsOuvert } = useGetClientTicketsOuverts();
  const { tickets : ticketsFerme, refetch: fetchTicketsFerme } = useGetClientTicketsFermes();

  const loadTicketsOuvert = useCallback(async () => {
    if(isConnected && isConnectedToListTicket){
      setLoadingOuvert(true);
      try {
        await fetchTicketsOuvert(localStorage.getItem('client_id'));
        setErrorOuvert(null);
      } catch (error) {
        setErrorOuvert(error.message || "Erreur lors du chargement des tickets ouverts");
      } finally {
        setLoadingOuvert(false);
      }
    }
  }, [fetchTicketsOuvert, isConnected, isConnectedToListTicket]);

  const loadTicketsFerme = useCallback(async () => {
    if(isConnected && isConnectedToListTicket){
      setLoadingFerme(true);
      try {
        await fetchTicketsFerme(localStorage.getItem('client_id'));
        setErrorFerme(null);
      } catch (error) {
        setErrorFerme(error.message || "Erreur lors du chargement des tickets fermés");
      } finally {
        setLoadingFerme(false);
      }
    }
  }, [fetchTicketsFerme, isConnected, isConnectedToListTicket]);

  const refreshTickets = useCallback(async () => {
    await Promise.all([loadTicketsOuvert(), loadTicketsFerme()]);
  }, [loadTicketsOuvert, loadTicketsFerme]);

  // Charger les tickets au montage initial
  React.useEffect(() => {
    refreshTickets();
  }, [refreshTickets]);

  return (
    <TicketContext.Provider
      value={{
        ticketsOuvert,
        ticketsFerme,
        loadingOuvert,
        loadingFerme,
        errorOuvert,
        errorFerme,
        isConnectedToListTicket,
        setIsConnectedToListTicket,
        refreshTickets,
        loadTicketsOuvert,
        loadTicketsFerme
      }}
    >
      {children}
    </TicketContext.Provider>
  );
};

export default TicketContext; 